/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceResponse } from './InvoiceResponse';
import {
    InvoiceResponseFromJSON,
    InvoiceResponseFromJSONTyped,
    InvoiceResponseToJSON,
    InvoiceResponseToJSONTyped,
} from './InvoiceResponse';

/**
 * Response light for get financial channel
 * @export
 * @interface FinancialChannelLightResponse
 */
export interface FinancialChannelLightResponse {
    /**
     * Unique identifier of the financial channel
     * @type {number}
     * @memberof FinancialChannelLightResponse
     */
    id?: number;
    /**
     * The title of financial channel
     * @type {string}
     * @memberof FinancialChannelLightResponse
     */
    title?: string;
    /**
     * true if channel is BankCard, DigitalPayment, LuTp, LuTpSocial or LuPid
     * @type {boolean}
     * @memberof FinancialChannelLightResponse
     */
    isThirdPartyChannel?: boolean;
    /**
     * Indicate if the financial channel is active
     * @type {boolean}
     * @memberof FinancialChannelLightResponse
     */
    active?: boolean;
    /**
     * The type of financial channel
     * @type {string}
     * @memberof FinancialChannelLightResponse
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof FinancialChannelLightResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialChannelLightResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<InvoiceResponse>}
     * @memberof FinancialChannelLightResponse
     */
    invoiceGroups?: Array<InvoiceResponse>;
}

/**
 * Check if a given object implements the FinancialChannelLightResponse interface.
 */
export function instanceOfFinancialChannelLightResponse(value: object): value is FinancialChannelLightResponse {
    return true;
}

export function FinancialChannelLightResponseFromJSON(json: any): FinancialChannelLightResponse {
    return FinancialChannelLightResponseFromJSONTyped(json, false);
}

export function FinancialChannelLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialChannelLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'isThirdPartyChannel': json['isThirdPartyChannel'] == null ? undefined : json['isThirdPartyChannel'],
        'active': json['active'] == null ? undefined : json['active'],
        'type': json['type'] == null ? undefined : json['type'],
        'count': json['count'] == null ? undefined : json['count'],
        'total': json['total'] == null ? undefined : json['total'],
        'invoiceGroups': json['invoiceGroups'] == null ? undefined : ((json['invoiceGroups'] as Array<any>).map(InvoiceResponseFromJSON)),
    };
}

export function FinancialChannelLightResponseToJSON(json: any): FinancialChannelLightResponse {
    return FinancialChannelLightResponseToJSONTyped(json, false);
}

export function FinancialChannelLightResponseToJSONTyped(value?: FinancialChannelLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'isThirdPartyChannel': value['isThirdPartyChannel'],
        'active': value['active'],
        'type': value['type'],
        'count': value['count'],
        'total': value['total'],
        'invoiceGroups': value['invoiceGroups'] == null ? undefined : ((value['invoiceGroups'] as Array<any>).map(InvoiceResponseToJSON)),
    };
}

